import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DepartmentMapCourseDetails from "./routes/DepartmentMapCourseDetails";

export default store => ({
  path: "course",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade course" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [DepartmentMapCourseDetails(store)],
});
